export default class RtkSettingInfo {
  static fromApi(responseData) {
    let info = new RtkSettingInfo()
    info.host = responseData.host
    info.port = responseData.port
    info.mountpoint = responseData.mountpoint
    info.baseUserId = responseData.baseUserId
    info.basePassword = responseData.basePassword
    info.roverUserId = responseData.roverUserId
    info.roverPassword = responseData.roverPassword
    return info
  }
}
